export default "__VITE_PUBLIC_ASSET__87528432__"